import React, { createContext, PropsWithChildren, useContext } from "react"

import { FrontendConfig } from "./types"

const FrontendConfigContext = createContext<FrontendConfig>({} as FrontendConfig)

export const useFrontendConfig = () => useContext(FrontendConfigContext)

export const FrontendConfigProvider = ({ children, config }: PropsWithChildren & { config: FrontendConfig }) => (
	<FrontendConfigContext.Provider value={config}>
		{children}
	</FrontendConfigContext.Provider>)
